export const msalConfig = {
  auth: {
    clientId: "7acf24dc-e3f1-44a8-94ce-01b19a591265",
    authority: "https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1/v2.0/",
    redirectUri: "https://portaldev.oi.rabobank.nl",
  },
};

export const loginRequest = {
  scopes: ["https://portal2dev.oi.rabobank.nl/user_impersonation"], 
};
